import { authRoles } from './auth/authRoles'

/** Main app nav: filtered in Sidenav by `auth` vs `user.role`. */
export const navigations = [
    {
        name: 'Dashboard',
        path: '/dashboard/default',
        icon: 'dashboard',
    },
    {
        name: 'Records',
        icon: 'people',
        auth: authRoles.admin_store_manager,
        children: [
            {
                name: 'New',
                path: '/pages/new-record/new',
                iconText: 'NE',
            },
            {
                name: 'All List',
                path: '/pages/record-list',
                iconText: 'RL',
            },
            {
                name: "Awaiting Photo",
                path: '/pages/await-photo',
                iconText: 'AP',
            }
        ],
    },
    {
        name: 'Locations',
        icon: 'store',
        /** ADMIN (and SA if ever merged here); not STORE_MANAGER */
        auth: authRoles.admin,
        children: [
            {
                name: 'New Location',
                path: '/pages/new-location/new',
                iconText: 'NL',
            },
            {
                name: 'Location List',
                path: '/pages/location-list',
                iconText: 'LL',
            }
        ],
    },
    {
        name: 'Orders',
        icon: 'shopping_cart',
        auth: authRoles.admin_store_manager,
        children: [
            {
                name: 'Cart',
                path: '/pages/orders/cart',
                iconText: 'CC',
            },
            {
                name: 'Order List',
                path: '/pages/orders/',
                iconText: 'CO',
            }
        ],
    }
]

export const navigationSA = [
    {
        name: 'Dashboard',
        path: '/dashboard/analytics',
        icon: 'analytics',
        // Always available to SA (not gated by sectionAccess)
        saAlwaysShow: true,
    },
    // {
    //     name: 'My Orders',
    //     path: '/pages/sa-orders',
    //     icon: 'shopping_cart',
    //     auth: authRoles.sa,
    //     saAlwaysShow: true,
    // },
    {
        name: 'Clients',
        icon: 'people',
        auth: authRoles.sa,
        saSection: 'clients',
        children: [
            {
                name: 'New Client',
                path: '/pages/new-client/new',
                iconText: 'NC',
                saSection: 'clients',
                saMinLevel: 'write',
            },
            {
                name: 'All Clients',
                path: '/pages/client-list',
                iconText: 'CL',
                saSection: 'clients',
            },
        ],
    },
    {
        name: 'Jobs',
        icon: 'batch_prediction',
        auth: authRoles.sa,
        saSection: 'jobs',
        children: [
            {
                name: 'New Job',
                path: '/pages/jobs/new-job',
                iconText: 'NJ',
                saSection: 'jobs',
            },
            {
                name: 'In Production',
                path: '/pages/jobs/in-production',
                iconText: 'IP',
                saSection: 'jobs',
            },
            {
                name: 'Dispatched',
                path: '/pages/jobs/dispatched-jobs',
                iconText: 'FJ',
                saSection: 'jobs',
            },
        ],
    },
]

export const footerNavigationSA = [
    {
        name: 'Settings',
        icon: 'settings',
        path: '/settings/account-settings',
        saSection: 'settings',
        // Always visible for SA (password change); Authorised Admins gated in UI
        saAlwaysShow: true,
    },
]


